import api from "./api";
import { ServiceBookingSettings } from "../types/store";

export const fetchServiceBookingSettings = async () => {
  const response = await api.get<ServiceBookingSettings>("/service-booking-settings");
  return response.data;
};
